import React from "react";
import { Avatar, Upload, Spin } from "antd";
import { UserOutlined, CameraOutlined } from "@ant-design/icons";

const ProfileAvatar = ({ avatarUrl, onAvatarChange, loading }) => {
  return (
    <div className="contacts-avatar">
      <Upload
        showUploadList={false}
        accept="image/*"
        beforeUpload={onAvatarChange}
        disabled={loading}
      >
        <Spin spinning={loading}>
          <Avatar
            size={80}
            src={avatarUrl}
            icon={<UserOutlined />}
            className="contacts-avatar__icon"
          />
          <span className="profile-avatar__camera-icon">
            <CameraOutlined style={{ fontSize: 16 }} />
          </span>
        </Spin>
      </Upload>
    </div>
  );
};

export default ProfileAvatar;
